import React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";

import { cn } from "../../lib/utils";
import { dentalIcons } from "../../../dentail-indetifcation/utils-icons/dentalIcons";

const Slider = React.forwardRef((props, ref) => {
  const { className, ...rest } = props;

  return (
    <div className="flex items-center gap-2 mt-1 w-full">
      {/* <span className="font-semibold text-[#C3C4C4]">-</span> */}
      <img src={dentalIcons.minus} alt="minus" className="h-4" />
      <SliderPrimitive.Root
        ref={ref}
        className={cn(
          "relative flex w-full touch-none select-none items-center",
          className
        )}
        {...rest}
      >
        <SliderPrimitive.Track className="relative h-3 w-full grow overflow-hidden rounded-full bg-[#FFFFFF] border border-[#EFEFEF]">
          <SliderPrimitive.Range className="absolute h-full bg-[#20C3FF]" />
        </SliderPrimitive.Track>
        <SliderPrimitive.Thumb className="block h-5 w-5 rounded-full border-4 shadow-md border-white bg-[#20C3FF] ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50" />
      </SliderPrimitive.Root>
      {/* <span className="font-semibold text-[#C3C4C4] block">+</span> */}
      <img src={dentalIcons.plus} alt="plus" className="h-4" />
    </div>
  );
});

Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
